type ErrorHandler = (error: unknown) => void

let handler: ErrorHandler | null = null

export const registerGlobalErrorHandler = (fn: ErrorHandler | null): void => {
  handler = fn
}

export const emitGlobalQueryError = (error: unknown): void => {
  if (handler) {
    handler(error)
  } else {
    console.error('Unhandled query error (snackbar bridge not mounted yet):', error)
  }
}
